/** Returns a persistent device fingerprint stored in localStorage. */
export function getDeviceId() {
  const KEY = "bompay_device_id";
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = "dev_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem(KEY, id);
  }
  return id;
}

/** Attach device-id header to every axios request. Call once in App.js. */
export function attachDeviceHeader(axiosInstance) {
  axiosInstance.interceptors.request.use((config) => {
    config.headers["X-Device-ID"] = getDeviceId();
    return config;
  });
}
